






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import PatientAcquisitionExportationFrameFoot from '@/components/patients/acquisition/exportation/frames/PatientAcquisitionExportationFrameFoot.vue';

@Component({
  components: { PatientAcquisitionExportationFrameFoot },
})
export default class PatientAcquisitionExportationFrameWalkingMeta extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  // -- CALCULS --------------------------------------------------------------------------------------------------------

  get strideLengthLeft(): number {
    const rsl = this.acquisition!.computed_data.left.aggregates.stride_length.avg;
    return parseFloat(rsl.toFixed(2));
  }

  get strideLengthRight(): number {
    const rsl = this.acquisition!.computed_data.right.aggregates.stride_length.avg;
    return parseFloat(rsl.toFixed(2));
  }

  // -- STRIDE LENGTH --------------------------------------------------------------------------------------------------

  get strideLength() {
    return {
      left: this.acquisition!.computed_data.left.aggregates.stride_length.avg * 100,
      right: this.acquisition!.computed_data.right.aggregates.stride_length.avg * 100,
    };
  }

  get strideLengthValue(): any {
    return {
      left: {
        value: this.strideLength.left,
        valStatut: this.$pdc.helper!.refint.getGeneral(
          this.patient!.infos.gender,
          this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
          'stride_length',
          this.strideLength.left,
        ),
      },
      right: {
        value: this.strideLength.right,
        valStatut: this.$pdc.helper!.refint.getGeneral(
          this.patient!.infos.gender,
          this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
          'stride_length',
          this.strideLength.right,
        ),
      },
    };
  }

  get strideLengthRange() {
    return {
      name: this.$t('commons.standards.stride-length') as string,
      infos: {
        unit: 'cm',
        range: this.$pdc.helper!.refint.getRange(
          this.patient!.infos.gender,
          this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
          'GENERAL',
          'stride_length',
          'abs',
        ),
      },
      left: this.strideLengthValue.left,
      right: this.strideLengthValue.right,
    };
  }

  // -- STRIDE ---------------------------------------------------------------------------------------------------------

  get stride() {
    return {
      left:
        this.$pdc.helper!.secToMs(this.acquisition!.computed_data.left.aggregates.swing_time.avg) +
        this.$pdc.helper!.secToMs(this.acquisition!.computed_data.left.aggregates.stance_time.avg),
      right:
        this.$pdc.helper!.secToMs(this.acquisition!.computed_data.right.aggregates.swing_time.avg) +
        this.$pdc.helper!.secToMs(this.acquisition!.computed_data.right.aggregates.stance_time.avg),
    };
  }

  get strideValue(): any {
    return {
      left: {
        value: this.stride.left,
        valStatut: this.$pdc.helper!.refint.getProSup(
          this.patient!.infos.gender,
          this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
          'stride',
          'abs',
          this.stride.left,
        ),
      },
      right: {
        value: this.stride.right,
        valStatut: this.$pdc.helper!.refint.getProSup(
          this.patient!.infos.gender,
          this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
          'stride',
          'abs',
          this.stride.right,
        ),
      },
    };
  }

  get strideRange() {
    return {
      infos: {
        unit: 'ms',
        range: this.$pdc.helper!.refint.getRange(
          this.patient!.infos.gender,
          this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
          'PRO_SUP',
          'stride',
          'abs',
        ),
      },
      left: this.strideValue.left,
      right: this.strideValue.right,
    };
  }

  // -- SYMMETRY -------------------------------------------------------------------------------------------------------

  get symmetry() {
    return parseFloat(
      (
        (1 -
          Math.abs(
            this.$pdc.helper!.secToMs(this.acquisition!.computed_data.left.aggregates.swing_time.avg) /
              this.$pdc.helper!.secToMs(this.acquisition!.computed_data.left.aggregates.stance_time.avg) -
              this.$pdc.helper!.secToMs(this.acquisition!.computed_data.right.aggregates.swing_time.avg) /
                this.$pdc.helper!.secToMs(this.acquisition!.computed_data.right.aggregates.stance_time.avg),
          ) /
            Math.max(
              this.$pdc.helper!.secToMs(this.acquisition!.computed_data.left.aggregates.swing_time.avg) /
                this.$pdc.helper!.secToMs(this.acquisition!.computed_data.left.aggregates.stance_time.avg),
              this.$pdc.helper!.secToMs(this.acquisition!.computed_data.right.aggregates.swing_time.avg) /
                this.$pdc.helper!.secToMs(this.acquisition!.computed_data.right.aggregates.stance_time.avg),
            )) *
        100
      ).toFixed(1),
    );
  }

  get symmetryColor() {
    switch (true) {
      case this.symmetry >= 0 && this.symmetry <= 80:
        return 'red';
      case this.symmetry > 80 && this.symmetry <= 95:
        return 'orange';
      case this.symmetry > 95 && this.symmetry <= 100:
        return 'green';
      default:
        return 'black';
    }
  }

  // -------------------------------------------------------------------------------------------------------------------

  getColor(status: number) {
    switch (status) {
      case 0:
        return 'red';
      case 1:
        return 'orange';
      case 2:
        return 'green';
      default:
        return 'black';
    }
  }
}
